var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Pane'),(_vm.type === 'contract')?_c('Contract',{attrs:{"list":_vm.list}}):_vm._e(),(_vm.error)?_c('a-card',{staticClass:"container"},[_c('a-result',{attrs:{"status":"500","title":"分享已过期"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }